import React from "react";

const Image = ({ src, alt, height = 100, width = 100 }) => {
    const icon = `http://dummyimage.com/${height}x${width}text=${alt}`;
    return (
        <div
            style={{
                backgroundImage: `url(${src || icon})`,
                width: `${height}px`,
                height: `${width}px`,
            }}
            className="img-container doctor-pic custom-img"
        ></div>
    );
};
export default Image;
